import React from "react";
import { useLocation } from "react-router-dom";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import SEO from "@/components/SEO";
import RichContent from "@/components/RichContent";
import usePageContent, { s } from "@/hooks/usePageContent";
import { parseLocaleFromPath } from "@/lib/locale";

export default function Restorations() {
  const { locale } = parseLocaleFromPath(useLocation().pathname);
  const { data: page } = usePageContent("restorations", locale);

  return (
    <>
      <SEO title={page?.meta_title} description={page?.meta_description} />
      <section className="bg-background grain-bg">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 py-16 lg:py-24">
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.3em] text-primary mb-4">{s(page, "eyebrow")}</div>
            <h1 className="font-serif text-5xl lg:text-6xl text-foreground leading-[1.05]">{s(page, "title")}</h1>
            <p className="mt-5 text-lg text-foreground/75">{s(page, "subtitle")}</p>
          </div>

          <div className="mt-12 lg:mt-16 rounded-lg overflow-hidden border border-border/60 shadow-ambient" data-testid="restoration-slider">
            <ReactCompareSlider
              itemOne={
                <ReactCompareSliderImage
                  src="/seed/restoration_before.webp"
                  alt={s(page, "slider_before")}
                  style={{ objectFit: "cover" }}
                />
              }
              itemTwo={
                <ReactCompareSliderImage
                  src="/seed/restoration_after.webp"
                  alt={s(page, "slider_after")}
                  style={{ objectFit: "cover" }}
                />
              }
              style={{ height: "min(70vh, 640px)" }}
            />
          </div>
          <p className="mt-4 text-sm text-muted-foreground italic text-center" data-testid="restoration-caption">
            {s(page, "slider_caption")}
          </p>

          <div className="mt-16 grid lg:grid-cols-2 gap-12 lg:gap-16" data-testid="restoration-body">
            <div className="space-y-5 text-foreground/85 text-lg leading-relaxed">
              <RichContent html={s(page, "p1")} />
              <RichContent html={s(page, "p2")} />
            </div>
            <div className="space-y-5 text-foreground/85 text-lg leading-relaxed">
              <RichContent html={s(page, "p3")} />
              <RichContent html={s(page, "p4")} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
